/**
 * ログイン API や UserInfo に保存される hospitalType を正規化する。
 * バックエンドが英字・日本語・列挙値など別形式の場合でも FACILITY を判別できるようにする。
 */
export function normalizeHospitalType(raw: unknown): 'HOSPITAL' | 'FACILITY' {
  if (raw == null || raw === '') {
    return 'HOSPITAL';
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    if (raw === 2) {
      return 'FACILITY';
    }
    if (raw === 1) {
      return 'HOSPITAL';
    }
  }
  const s = String(raw).trim();
  if (!s) {
    return 'HOSPITAL';
  }
  const u = s.toUpperCase();
  if (u === 'FACILITY' || s === '施設') {
    return 'FACILITY';
  }
  if (u === 'HOSPITAL' || s === '病院') {
    return 'HOSPITAL';
  }
  if (s === '2') {
    return 'FACILITY';
  }
  if (s === '1') {
    return 'HOSPITAL';
  }
  if (/^facility$/i.test(s)) {
    return 'FACILITY';
  }
  if (/^hospital$/i.test(s)) {
    return 'HOSPITAL';
  }
  return 'HOSPITAL';
}
